<template>
  <div class="no-data">
    <div class="ico">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M40.5848 78.9968C61.9965 78.7263 79 60.8727 79 39.4123V1.99187C79 1.45085 78.5502 1 78.0104 1H53.9896C53.4498 1 53 1.45085 53 1.99187V4.69696H27.9896C27.4498 4.69696 27 5.14782 27 5.68884V40.0435H1.98965C1.44986 40.0435 1 40.4944 1 41.0354C1.62976 62.2253 19.173 79.2673 40.5848 78.9968Z"
            fill="#E0E1E9"/>
        <path
            d="M65.9248 57.6069C65.9248 57.6069 66.0112 57.5529 66.0436 57.5204L72.539 53.1974L69.4048 51.5006L66.2706 52.2572L57.9704 20.5802C57.203 17.6406 54.2742 15.8141 51.2913 16.4301L11.7033 24.5034L10.3091 21.38L6.89395 27.2593C6.8183 27.3782 6.74263 27.5079 6.67779 27.6268V27.6484C6.00772 28.902 5.79152 30.4151 6.22382 31.8957L16.664 68.5441C17.053 69.9167 18.4688 70.7165 19.8414 70.3382L65.1142 57.996C65.3844 57.9203 65.633 57.7906 65.8599 57.6501L65.914 57.6177L65.9248 57.6069Z"
            fill="#E0E1E9" stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M71.7622 53.5535L24.0902 66.555C22.6419 66.944 21.1505 66.1118 20.7398 64.6636L9.74853 26.0699C8.78666 22.698 10.9049 19.2179 14.3417 18.5155L57.2153 9.77216C60.3495 9.13451 63.4404 11.0583 64.2402 14.1492L73.686 50.2248C74.0642 51.673 73.2104 53.1644 71.7622 53.5535Z"
            fill="white"/>
        <path
            d="M65.4516 18.8181L11.068 30.7604L9.7279 26.07C8.76603 22.698 10.8843 19.218 14.3211 18.5155L57.2055 9.77216C60.3396 9.13451 63.4306 11.0583 64.2304 14.1492L65.4516 18.8181Z"
            fill="#6C6E79"/>
        <path
            d="M18.3936 23.4184C18.6962 24.4884 18.0586 25.5475 16.9778 25.7853C15.8862 26.0231 14.7515 25.3314 14.4489 24.2614C14.1463 23.1915 14.7839 22.1215 15.8755 21.8946C16.967 21.6676 18.091 22.3593 18.3936 23.4292V23.4184Z"
            fill="white"/>
        <path
            d="M25.3751 21.9381C25.6669 22.9972 25.0509 24.0455 23.9809 24.2725C22.911 24.4994 21.7978 23.8186 21.506 22.7486C21.2142 21.6787 21.8302 20.6303 22.9109 20.4034C23.9917 20.1764 25.0833 20.8681 25.3751 21.9272V21.9381Z"
            fill="#E0E1E9"/>
        <path
            d="M11.0868 30.8424C11.0868 30.8424 11.411 27.6866 11.692 24.4552L10.3195 21.375L6.90426 27.2543C6.82861 27.3732 6.75301 27.5029 6.68816 27.6218V27.6434C6.01809 28.8971 5.8019 30.4101 6.2342 31.8907L7.62841 36.7974L11.0868 30.8316V30.8424Z"
            fill="#6C6E79"/>
        <path
            d="M71.7622 53.5535L24.0902 66.555C22.6419 66.944 21.1505 66.1118 20.7398 64.6636L9.74853 26.0699C8.78666 22.698 10.9049 19.2179 14.3417 18.5155L57.2153 9.77216C60.3495 9.13451 63.4404 11.0583 64.2402 14.1492L73.686 50.2248C74.0642 51.673 73.2104 53.1644 71.7622 53.5535Z"
            stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M34.0003 41.8058L26.943 43.5134C26.5107 43.6215 26.2513 44.0646 26.3702 44.4969L29.7097 56.4176L38.2153 54.202L34.9406 42.357C34.8325 41.9463 34.411 41.6977 33.9895 41.795L34.0003 41.8058Z"
            stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M44.2152 28.7587L37.4064 30.3042C36.9633 30.4015 36.7039 30.8446 36.8228 31.2877L42.7886 53.0109L51.0023 50.871L45.1662 29.3207C45.0582 28.91 44.6475 28.6615 44.226 28.7587H44.2152Z"
            fill="#6C6E79" stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M58.285 31.6058L51.7896 33.1188C51.3573 33.2161 51.0871 33.6592 51.206 34.0915L55.3993 49.73L63.3321 47.6658L59.236 32.1678C59.128 31.7571 58.7065 31.5085 58.2958 31.6058H58.285Z"
            fill="#E0E1E9" stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M23.3553 61.2827L70.1952 48.8972" stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M27.5596 48.6014L31.8657 42.3245" stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M35.4999 44.7638L29.0771 54.1231" stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path d="M33.4999 55.4171L37.0926 50.1731" stroke="#6C6E79" stroke-width="0.7" stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>

    </div>
    <div class="text">
      Нет данных
    </div>
  </div>
</template>

<script>
export default {
  name: "NoData",
  props: [],
  data: () => ({}),
  methods: {}
}
</script>

<style scoped>
.no-data {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 20px;
  .ico {
    background-image: image("@/assets/images/calendar.svg");
  }

  .text {
    font-size: 16px;
    font-weight: bold;
    color: var(--grey);
  }
}
</style>
